import { NotificationType, Notifications } from "@twilio/flex-ui/node_modules/@twilio/flex-ui-core";

export const BROWSER_NOTIFICATION_ID = "flexBrowserNotification";

function checkIfAlreadyRegistered(flex) {
    const notification = flex.Notifications.registeredNotifications.get(BROWSER_NOTIFICATION_ID);
    if(notification){
        return notification;
    }
    
    //sometimes a notification may still be registered even though it cannot be retrieved. therefore, delete it so it can be re-registered.
    flex.Notifications.registeredNotifications.delete(BROWSER_NOTIFICATION_ID);
    
    return null
}

export function registerBrowserNotification({ flex, content, reservationId, requireInteraction }) {    
    const requireInteractionTimeout = !requireInteraction ? 5000 : 0 
    const notification = checkIfAlreadyRegistered(flex);
    
    if (notification) {        
        notification.options.browser.body = content
        notification.options.browser.options.tag = reservationId
        notification.options.browser.options.requireInteraction = requireInteraction
    } else {
        flex.Notifications.registerNotification({
            id: BROWSER_NOTIFICATION_ID,
            closeButton: true,            
            timeout: requireInteractionTimeout,
            type: NotificationType.information,
            options: {
                browser: {
                    title: "Agent Desktop",
                    body: content,
                    onClick: () => {
                        window.parent.focus();
                        window.focus();
                        this.close();
                    },
                    options: {
                        tag: reservationId,
                        requireInteraction: requireInteraction,
                        icon: "/assets/chat-logo.png",
                    }
                }
            }
        });
    }
}